define('viewModels/widgets/MakeCallAutocompleteList',[
    'lib/lodash4',
    'lib/knockout',
    'lib/bluebird',
    'services/userService',
    'services/queuesService',
    'services/userStatusService',
    'viewModels/ViewModel'
], function (_, ko, Promise, userService, queueConfigService, userStatusService, ViewModel) {

    'use strict';

    var SEARCH_DELAY = 200;

    /**
     * Provides a list of destinations for making a call or transferring a chat/call.
     *
     * @param options {Object} The options object for this viewmodel:
     *      isTransfer - indicates if this is being used to transfer a conversation
     *      isChat - indicates if this is being used to transfer a chat
     *      setItemCallback - fn to call when the selected item has been updated
     */
    return ViewModel.extend(function (options) {
        options = options || {};
        var self = this;
        self.value = ko.observable('');
        self.searchResults = ko.observableArray();
        var selection = {};
        var QUEUE_ID_ATTR = options.isTransfer ? 'queueId' : 'callQueueId';
        var USER_ID_ATTR = options.isTransfer ? 'userId' : 'callUserId';
        var ADDRESS_ATTR = options.isChat ? 'username' : (options.isTransfer ? 'address' : 'call');
        var queryPromise = Promise.resolve();
        var lazySearch = _.debounce(function () {
            if (queryPromise) {
                queryPromise.cancel();
            }

            var query = {name: '*' + self.value().trim() + '*'};
            var usersPromise = userService.getUsers(_.assign({expand: 'primaryPresence'}, query));
            var queuesPromise = options.hideQueues ? Promise.resolve({entities: []}) : queueConfigService.getQueues(query, { returnModels: false });

            queryPromise = Promise.all([usersPromise, queuesPromise])
                .spread(function (users, queues) {
                    // get the first 5 users
                    var firstFiveUsers = _.take(users(), 5);

                    // fill in user status
                    _.forEach(firstFiveUsers, function (user) {
                        user.statusType = self.computed(function () {
                            if (user.primaryPresence() && user.primaryPresence().presenceDefinition) {
                                return userStatusService.findPresence(user.primaryPresence().presenceDefinition().id()).type;
                            }
                            return null;
                        });

                        user.formattedNumber = user.phoneNumber();

                        user.isQueue = false;

                    });

                    _.forEach(queues.entities, function (queue) {
                        queue.isQueue = true;
                    });

                    // combine queue search results and sort by name
                    var sortedList = _.sortBy(firstFiveUsers.concat(queues.entities), [function (item) {
                        return _.isFunction(item.name) ? item.name() : item.name;
                    }]);

                    // save the top 5 results
                    self.searchResults(_.take(sortedList, 5));

                    // if there is an exact match, then use it as the call destination
                    if (self.searchResults().length === 1) {
                        self.setItem(_.isFunction(self.searchResults()[0].name) ? self.searchResults()[0].name() : self.searchResults()[0].name);
                    }
                })
                .cancellable()
                .catch(function (error) {
                    if (error.name === 'CancellationError') {
                        usersPromise.cancel();
                        queuesPromise.cancel();
                    }
                });
        }, SEARCH_DELAY);

        /**
         * When an item is selected from the list, update the selection based on if it's a queue or a user.
         * @param item the selected item name
         */
        self.setItem = function (item, evt, id) {
            var searchItem = _.find(self.searchResults(), function (result) {
                if (id && _.isString(id)) {
                    return result.id === id;
                }
                if (_.isFunction(result.name)) {
                    return result.name() === item;
                } else {
                    return result.name === item;
                }
            });

            selection = {};

            if (searchItem && searchItem.isQueue) {
                selection[QUEUE_ID_ATTR] = searchItem.id;
            } else if (searchItem) {
                selection[USER_ID_ATTR] = searchItem.id;
            } else {
                selection[ADDRESS_ATTR] = item;
            }

            if (options.setItemCallback) {
                options.setItemCallback();
            }
        };

        /**
         * Get the current selection from the auto complete list.
         *
         * @returns {Promise} A promise that resolves to the current selection from the list
         */
        self.getSelection = function () {
            return queryPromise.then(function () {
                return selection;
            });
        };

        /**
         * Perform the search of users and queues.  The goal is to return the first 5 results (sorted by name).
         */
        self.computed(function () {
            var isMatch = _.some(self.searchResults.peek(), function (item) {
                if (_.isFunction(item.name)) {
                    return item.name() === self.value();
                } else {
                    return item.name === self.value();
                }
            });

            if (isMatch) {
                queryPromise = Promise.resolve();
                return;
            }

            // they are adding more text to the input field so update the call options to just dial the value
            selection = {};
            selection[ADDRESS_ATTR] = self.value();
            if (options.setItemCallback) {
                options.setItemCallback();
            }

            if (self.value().length > 0) {
                lazySearch();
            } else if (self.value().length === 0) {
                self.searchResults.removeAll();
            }
        });
    });
});

